import AvataUpload from "components/AvataUpload";
import {
  Button,
  Col,
  DatePicker,
  Form,
  FormInstance,
  Input,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
import React, { FC, useEffect, useState } from "react";
import styled from "@emotion/styled";
import SettingAvatar from "./SettingAvatar";
import {
  useGetMasterDistrict,
  useGetMasterSubDistrict,
  useGetMasterProvice,
} from "hooks/useMasterData";
import {
  MasterDistrictData,
  MasterProvinceData,
  MasterSubDistrictData,
  UserRoleWithoutAdmin,
  UserSystemData,
} from "services/interface";
import { useGetUserRoleWithoutAdmin } from "hooks/useAuth";

interface UserSystemFormProps {
  form: FormInstance;
  onFinish: (values: any) => void;
  isPending: boolean;
  editData?: UserSystemData | undefined;
}

const { Option } = Select;

const UserSystemForm: FC<UserSystemFormProps> = ({
  form,
  onFinish,
  isPending,
  editData,
}) => {
  const [province, setProvince] = useState<MasterProvinceData[]>([]);
  const [district, setDistrict] = useState<MasterDistrictData[]>([]);
  const [subDistrict, setSubDistrict] = useState<MasterSubDistrictData[]>([]);

  const [roleList, setRoleList] = useState<UserRoleWithoutAdmin[]>([]);

  const [provinceId, setProvinceId] = useState<number>(0);
  const [districtId, setDistrictId] = useState<number>(0);

  const { data: masterProviceData, isLoading: proviceLoading } =
    useGetMasterProvice();
  // useGetMasterProvince();

  useEffect(() => {
    if (masterProviceData) {
      setProvince(masterProviceData);
    }
  }, [masterProviceData]);

  const childrenProvince: React.ReactNode[] = [];
  province?.map((item) => {
    childrenProvince.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const { data: masterDistrictData, isLoading: districtLoading } =
    useGetMasterDistrict(provinceId);

  useEffect(() => {
    if (masterDistrictData) {
      setDistrict(masterDistrictData);
    }
  }, [masterDistrictData]);

  const childrenDistrict: React.ReactNode[] = [];
  district?.map((item) => {
    childrenDistrict.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const { data: masterSubDistrictData, isLoading: subDistrictLoading } =
    useGetMasterSubDistrict(districtId);

  useEffect(() => {
    if (masterSubDistrictData) {
      setSubDistrict(masterSubDistrictData);
    }
  }, [masterSubDistrictData]);

  const childrenSubDistrict: React.ReactNode[] = [];
  subDistrict?.map((item) => {
    childrenSubDistrict.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const { data: roleUserWithoutAdmin, isLoading: roleUserWithoutAdminLoading } =
    useGetUserRoleWithoutAdmin();

  useEffect(() => {
    if (roleUserWithoutAdmin) {
      setRoleList(roleUserWithoutAdmin.data);
    }
  }, [roleUserWithoutAdmin]);

  const childrenRole: React.ReactNode[] = [];
  roleList?.map((item) => {
    childrenRole.push(
      <Option key={item.id} value={item.id}>
        {item.name}
      </Option>
    );
  });



  useEffect(() => {
    if (editData) {

      setProvinceId(editData.province_id || 0);
      setDistrictId(editData.district_id || 0);



    }
  }, [editData]);

  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 24 }}
      >
        <Row justify={"center"}>
          <SettingAvatar />
        </Row>

        <Form.Item
          name="first_name"
          labelAlign="left"
          label="ชื่อ"
          rules={[{ required: true, message: "กรุณากรอกชื่อ" }]}
        >
          <Input placeholder="กรุณากรอกชื่อ" />
        </Form.Item>
        <Form.Item
          name="last_name"
          labelAlign="left"
          label="นามสกุล"
          rules={[{ required: true, message: "กรุณากรอกนามสกุล" }]}
        >
          <Input placeholder="กรุณากรอกนามสกุล" />
        </Form.Item>



        <Form.Item
          name="mobile"
          labelAlign="left"
          label="เบอร์โทรศัพท์"
          rules={[
            { required: true, message: "กรุณากรอกเบอร์โทรศัพท์" },
            {
              pattern: /^[0-9\b]+$/,
              message: "กรุณากรอกเฉพาะตัวเลข",
            },
            {
              max: 10,
              message: "กรุณากรอกเบอร์โทรศัพท์ 10 หลัก",
            },
            {
              min: 10,
              message: "กรุณากรอกเบอร์โทรศัพท์ 10 หลัก",
            },
          ]}
        >
          <Input
            placeholder="กรุณากรอกเบอร์โทรศัพท์"
            maxLength={10}
            minLength={10}
          />
        </Form.Item>

        {/* <Form.Item
          name="username"
          labelAlign="left"
          label="ชื่อผู้ใช้งาน"
        //  rules={[{ required: true, message: "กรุณากรอกชื่อผู้ใช้งาน" }]}
        >
          <Input placeholder="กรุณากรอกชื่อผู้ใช้งาน" />
        </Form.Item> */}
        <Form.Item
          name="email"
          labelAlign="left"
          label="อีเมล"
          rules={[{ required: false, message: "กรุณากรอกอีเมล" }]}
        >
          <Input placeholder="กรุณากรอกอีเมล" />
        </Form.Item>

        <Form.Item
          label="บทบาท"
          labelAlign="left"
          className="form-transport"
          name="role_id"
          required
          rules={[
            {
              required: true,
              message: "กรุณาเลือกบทบาท",
            },
          ]}
        >
          <Select
            style={{ width: "100%", marginBottom: 12 }}
            showSearch
            placeholder="บทบาท"
            optionFilterProp="children"
            onChange={(value) => { }}
            notFoundContent={
              roleUserWithoutAdmin ? <Spin size="small" /> : null
            }
            loading={roleUserWithoutAdminLoading}
          >
            {childrenRole}
          </Select>
        </Form.Item>

        <Form.Item
          label="ที่อยู่"
          name="line_1"
          labelAlign="left"
          rules={[{ required: false, message: "กรุณากรอกที่อยู่" }]}
        >
          <Input placeholder="ที่อยู่" />
        </Form.Item>

        <Form.Item
          label="จังหวัด"
          labelAlign="left"
          className="form-transport"
          name="province"
          required
          rules={[
            {
              required: true,
              message: "กรุณาเลือกจังหวัด",
            },
          ]}
        >
          <Select
            style={{ width: "100%", marginBottom: 12 }}
            showSearch
            placeholder="จังหวัด"
            optionFilterProp="children"
            onChange={(value) => {
              setProvinceId(value);
              form.setFieldsValue({
                district: undefined,
                sub_district: undefined,
                zip_code: undefined,
              });
            }}
            notFoundContent={proviceLoading ? <Spin size="small" /> : null}
            loading={proviceLoading}
          >
            {childrenProvince}
          </Select>
        </Form.Item>

        <Form.Item
          label="อำเภอ"
          className="form-transport"
          labelAlign="left"
          name="district"
          required
          rules={[
            {
              required: false,
              message: "กรุณาเลือกอำเภอ",
            },
          ]}
        >
          <Select
            showSearch
            style={{ width: "100%" }}
            placeholder="อำเภอ"
            optionFilterProp="children"
            onChange={(value) => {
              setDistrictId(value);
            }}
            notFoundContent={districtLoading ? <Spin size="small" /> : null}
            loading={districtLoading}
          >
            {childrenDistrict}
          </Select>
        </Form.Item>

        <Form.Item
          label="ตำบล"
          labelAlign="left"
          name="sub_district"
          required
          rules={[
            {
              required: false,
              message: "กรุณาเลือกตำบล",
            },
          ]}
        >
          <Select
            showSearch
            placeholder="ตำบล"
            optionFilterProp="children"
            onChange={(value) => {
              subDistrict.map((item) => {
                if (item.id === value) {
                  // setZipCode(item.zip_code);
                  form.setFieldsValue({ zip_code: item.zip_code });
                }
              });
            }}
            notFoundContent={subDistrictLoading ? <Spin size="small" /> : null}
            loading={subDistrictLoading}
          >
            {childrenSubDistrict}
          </Select>
        </Form.Item>

        <Form.Item
          required
          label="รหัสไปรษณีย์"
          labelAlign="left"
          name="zip_code"
          rules={[
            {
              required: false,
              message: "กรุณากรอกรหัสไปรษณีย์",
            },
          ]}
        >
          <Input placeholder="รหัสไปรษณีย์" maxLength={5} minLength={5} />
        </Form.Item>

        <Form.Item>
          <WrapperButton>
            <Button
              style={{ width: 250 }}
              type="primary"
              size="large"
              htmlType="submit"
              disabled={isPending}
            >
              บันทึก
            </Button>
          </WrapperButton>
        </Form.Item>
      </Form>
    </>
  );
};

export default UserSystemForm;

const WrapperButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
`;
